import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Logo1 from '../../../src/assets/images/Iq Logo1.png';


export function Sidebar() {
  // Screen size ke mutabiq initial state set karein
  const [isOpen, setIsOpen] = useState(window.innerWidth >= 1024);
  const [openMenus, setOpenMenus] = useState({
    booking: false, expense: false, otherService: false, payment: false,
    otherIncome: false, supplier: false, butcher: false, holdAnimal: false,
    subcategories: false, reports: false, users: false,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem('role')?.toLowerCase();

  // Screen resize handle karne ke liye (Desktop vs Mobile)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setIsOpen(true);
      else setIsOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Mobile par link click karne ke baad sidebar band ho jaye
  useEffect(() => {
    if (window.innerWidth < 1024) setIsOpen(false);
  }, [location.pathname]);

  const handleDashboardClick = (e) => {
    e.preventDefault();
    const routes = { admin: '/admin', superadmin: '/super-admin', moderator: '/moderator-dashboard' };
    navigate(routes[userRole] || '/');
  };

  const toggleMenu = (menu) => {
    setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
  };

  const permissions = {
    admin: { booking: true, payment: true, expense: true, otherIncome: true, supplier: true, butcher: true, holdAnimal: true, otherService: true },
    superadmin: { booking: true, payment: true, expense: true, otherIncome: true, supplier: true, butcher: true, subcategories: true, holdAnimal: true, otherService: true, reports: true, users: true },
    moderator: { booking: true, expense: true, payment: true, otherService: true }
  };

  const activeMenus = permissions[userRole] || {};

  if (!userRole || !permissions[userRole]) return null;

  // UI Helper Classes
  const navItemClass = "group flex items-center justify-between px-4 py-3 text-[13px] font-bold uppercase tracking-wider rounded-xl transition-all duration-200 cursor-pointer mb-1";
  const subLinkClass = "block px-4 py-2 text-[15px] font-semibold text-slate-500 hover:text-indigo-600 hover:bg-indigo-50/50 rounded-lg transition-all duration-200 border-l-2 border-transparent hover:border-indigo-900 ml-4 mb-1";

  const MenuDropdown = ({ id, label, icon, children }) => {
    if (!activeMenus[id]) return null;
    return (
      <div className="space-y-1">
        <button onClick={() => toggleMenu(id)} className={`${navItemClass} w-full ${openMenus[id] ? 'bg-indigo-700 text-white shadow-md' : 'text-slate-600 hover:bg-slate-50'}`}>
          <div className="flex items-center gap-3">{icon}<span>{label}</span></div>
          <svg className={`w-4 h-4 transition-transform ${openMenus[id] ? 'rotate-180' : 'opacity-40'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
        </button>
        {openMenus[id] && <div className="mt-1 animate-in slide-in-from-top-1 duration-200">{children}</div>}
      </div>
    );
  };

  return (
    <>
      {/* MOBILE HEADER / TOGGLE BAR (Sirf Mobile par dikhay ga) */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-indigo-200 z-[55] flex items-center px-4">
        <button
          className="p-2 rounded-xl bg-green-600 text-white shadow-lg active:scale-95 transition-transform"
          onClick={() => setIsOpen(true)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
        <span className="ml-4 font-black text-slate-800 tracking-tight"><p className="text-2xl text-indigo-700" style={{ fontFamily: 'jameel noori nastaleeq' }}>
          الخدمت - اجتماعی قربانی جامع مسجد قباء
        </p></span>
      </div>

      {/* SIDEBAR MAIN CONTAINER */}
      <aside className={`
        fixed inset-y-0 left-0 z-[60] w-72 bg-indigo-100 border-r border-slate-100 flex flex-col
        transition-transform duration-300 ease-in-out transform
        ${isOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'}
        lg:translate-x-0 lg:shadow-none
      `}>

        {/* Branding & Close Button */}
        <div className="p-2  flex items-center justify-between border-b border-slate-50">
          <div className="flex items-center gap-1">
            {/* <div className="mx-auto h-30 w-68 items-center justify-center  shadow-md  border-indigo-800 overflow-hidden ">
                        <img src={Logo1} alt="header logo"  className="h-full w-full object-cover" />
              </div>    */}
            <div className="flex flex-col mx-auto pl-16 text-center mb-2 mt-4 ">
              <h2 className="text-5xl font-black text-indigo-800 mb-2" style={{ fontFamily: 'jameel noori nastaleeq' }}>
                الخدمت
              </h2>
              <div className="flex items-center w-full max-w-xs mb-2">
                <div className="flex-1 h-[2px] bg-indigo-200"></div>
                <div className="mx-4 text-indigo-400">◆</div>
                <div className="flex-1 h-[2px] bg-indigo-200"></div>
              </div>
              <p className="text-2xl text-indigo-700" style={{ fontFamily: 'jameel noori nastaleeq' }}>
                اجتماعی قربانی جامع مسجد قباء
              </p>
            </div>
          </div>
          <button className="lg:hidden p-2 text-slate-400 hover:text-red-500 transition-colors" onClick={() => setIsOpen(false)}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <nav className="flex-1 px-4 space-y-1 py-4 overflow-y-auto scrollbar-hide">
          <Link to="#" onClick={handleDashboardClick} className={`${navItemClass} ${location.pathname.includes('dashboard') ? 'bg-green-600 text-white shadow-lg' : 'text-slate-600 hover:bg-slate-50'}`}>
            <div className="flex items-center gap-3">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>
              <span>Dashboard</span>
            </div>
          </Link>

          <div className="pt-4 pb-2 px-4"><p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Operations</p></div>

          <MenuDropdown id="booking" label="Booking" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>}>
            <Link to="/moderator/find-share" className={subLinkClass}>Find Share</Link>
            <Link to="/moderator/add-new" className={subLinkClass}>Add New</Link>
            <Link to="/moderator/view-customer" className={subLinkClass}>View Customer</Link>
            <Link to="/moderator/view-share" className={subLinkClass}>View Share</Link>
          </MenuDropdown>

          <MenuDropdown id="holdAnimal" label="Hold Animal" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>}>
            <Link to="/hold-animal/add" className={subLinkClass}>Add New</Link>
            <Link to="/hold-animal/view" className={subLinkClass}>View</Link>
          </MenuDropdown>

          <MenuDropdown id="expense" label="Expense" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}>
            <Link to="/expense/add-expense" className={subLinkClass}>Add Expense</Link>
            <Link to="/expense/view-expense" className={subLinkClass}>View All</Link>
          </MenuDropdown>

          <MenuDropdown id="otherIncome" label="Other Income" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>}>
            <Link to="/other-income/add" className={subLinkClass}>Add Other Income</Link>
            <Link to="/other-income/view" className={subLinkClass}>View All</Link>
          </MenuDropdown>

          <MenuDropdown id="otherService" label="Other Service" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>}>
            <Link to="/othService/add" className={subLinkClass}>Add Service</Link>
            <Link to="/othService/view" className={subLinkClass}>View Service</Link>
          </MenuDropdown>

          <MenuDropdown id="payment" label="Payment" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>}>
            <Link to="/moderator/view-payment" className={subLinkClass}>View Payment</Link>
            <Link to="/moderator/payment-history" className={subLinkClass}>History</Link>
          </MenuDropdown>

          <div className="pt-4 pb-2 px-4"><p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Supply Chain</p></div>

          <MenuDropdown id="supplier" label="Supplier" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>}>
            <Link to="/supplier/add" className={subLinkClass}>Add Supplier</Link>
            <Link to="/supplier/view" className={subLinkClass}>View Suppliers</Link>
            <Link to="/supplier/payment" className={subLinkClass}>Payment</Link>
            <Link to="/supplier/sup-ledger" className={subLinkClass}>Ledger</Link>
          </MenuDropdown>

          <MenuDropdown id="butcher" label="Butcher" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879" /></svg>}>
            <Link to="/butcher/add" className={subLinkClass}>Add Butcher</Link>
            <Link to="/butcher/view" className={subLinkClass}>View Butchers</Link>
            <Link to="/butcher/payment" className={subLinkClass}>Payment</Link>
          </MenuDropdown>

          <MenuDropdown id="reports" label="Reports" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 2v-6m-8 13h11a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2z" /></svg>}>
            <Link to="/reports/delivery" className={subLinkClass}>Delivery Counter</Link>
            <Link to="/reports/weight" className={subLinkClass}>Weight Report</Link>
            <Link to="/reports/fisabilillah" className={subLinkClass}>Fisabilillah</Link>
            <Link to="/reports/daily-share" className={subLinkClass}>Daily Share Count</Link>
          </MenuDropdown>
          <div className="pt-4 pb-2 px-4"><p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Registration & Setup</p></div>

          <MenuDropdown id="subcategories" label="Sub Categories" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>}>
            <Link to="/subcategories/add" className={subLinkClass}>Add New</Link>
            <Link to="/subcategories/view" className={subLinkClass}>View</Link>
          </MenuDropdown>

          <MenuDropdown id="users" label="User Management" icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>}>
            <Link to="/users/add" className={subLinkClass}>Add Users</Link>
            <Link to="/users/view" className={subLinkClass}>View</Link>
          </MenuDropdown>
        </nav>


      </aside>

      {/* OVERLAY (Background Blur on Mobile) */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-slate-900/40 backdrop-blur-[2px] z-[55] transition-opacity duration-300"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
}